module.exports = __webpack_public_path__ + "img/bg_image_5.87e29d49.png";